/* src/app/views/terms/terms.component.css */
/*# sourceMappingURL=terms.component.css.map */
